import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { routes } from "@/lib/routes";

const SUGGESTIONS = [
  "Guitar lessons",
  "Yoga near me",
  "Cooking class",
  "Tennis coach",
  "Photography",
  "Swimming lessons",
];

export const HomepageSearch = () => {
  const [query, setQuery] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (query.trim()) {
      navigate(`${routes.browseExperiences()}&search=${encodeURIComponent(query.trim())}`);
    } else {
      navigate(routes.browseExperiences());
    }
  };

  const handleSuggestion = (s: string) => {
    navigate(`${routes.browseExperiences()}&search=${encodeURIComponent(s)}`);
  };

  return (
    <div className="w-full max-w-lg mx-auto">
      <form onSubmit={handleSubmit} className="relative">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-muted-foreground pointer-events-none" />
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="What do you want to learn?"
          className="w-full h-12 sm:h-14 pl-12 pr-4 rounded-full border border-border bg-card shadow-lg text-base placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/40 focus:border-primary transition-all"
        />
      </form>
      <div className="flex flex-wrap items-center justify-center gap-2 mt-3">
        {SUGGESTIONS.map((s) => (
          <button
            key={s}
            onClick={() => handleSuggestion(s)}
            aria-label={`Search for ${s}`}
            className="px-3 py-1 text-xs rounded-full border border-border bg-background hover:bg-primary/5 hover:border-primary/30 text-muted-foreground hover:text-foreground transition-colors"
          >
            {s}
          </button>
        ))}
      </div>
    </div>
  );
};
